import { Tooltip, TooltipProps } from '@alkem/react-ui-tooltip';
import { useRef, useEffect, useState, ReactNode } from 'react';
import './index.scss';

interface Props {
  children?: ReactNode;
  id: string;
  label?: string;
  lines?: number;
  place?: TooltipProps['place'];
}

export function Ellitips({
  children,
  id,
  label,
  lines = 1,
  place = 'top',
}: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLSpanElement>(null);
  const [withTooltip, setWithTooltip] = useState(false);
  let timer: NodeJS.Timeout | null = null;

  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
  };

  const onMouseEnter = () => {
    if (contentRef.current && containerRef.current) {
      let displayTooltip = false;
      if (lines > 1) {
        displayTooltip =
          contentRef.current.offsetHeight > containerRef.current.offsetHeight;
      } else {
        displayTooltip =
          contentRef.current.offsetWidth > containerRef.current.offsetWidth;
      }
      if (displayTooltip) {
        timer = setTimeout(() => {
          setWithTooltip(true);
          if (containerRef.current) {
            Tooltip.show(containerRef.current);
          }
        }, 200);
      }
    }
  };

  const onMouseLeave = () => {
    clearTimer();
    if (withTooltip) {
      setWithTooltip(false);
    }
  };

  useEffect(() => () => clearTimer());

  return (
    <div
      className={`Ellitips Ellitips--line${lines} ${
        lines > 1 ? 'Ellitips--multiLines' : ''
      }`}
      data-tip
      data-for={id}
      ref={containerRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={`${id}-wrapper`}
    >
      <span
        className="Ellitips__content"
        ref={contentRef}
        data-testid={`${id}-content`}
      >
        {children || label}
      </span>
      {withTooltip && (
        <Tooltip place={place} id={id}>
          {label || children}
        </Tooltip>
      )}
    </div>
  );
}

export default Ellitips;
